import NextImage from "@/components/global/NextImage";
import { validateImgSrc } from "@/utils/global";
import React, { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

export default function BundleOptions({ data, locale }) {
  const products = useMemo(
    () => data?.sort((a, b) => a?.position - b?.position),
    [data]
  );
  return (
    products?.length > 0 && (
      <section>
        <p className="font-bold">
          {locale === "ar" ? "مكونات المجموعة" : "Bundle components"}
        </p>
        <div className="flex flex-col gap-3 my-4">
          {products?.map((item) => (
            <div key={uuidv4()} className=" flex items-center gap-6 ">
              <div className="size-12 p-2 flex items-center justify-center rounded-md border-2">
                <NextImage
                  src={validateImgSrc(
                    item?.product_links?.at(0)?._media_?.image?.at(0)?.image
                  )}
                  alt=""
                  width={48}
                  height={48}
                  className="size-full object-contain"
                />
              </div>
              <h4 className="font-bold text-sm">{item?.title}</h4>
            </div>
          ))}
        </div>
      </section>
    )
  );
}
